import Service from "@/services";

export default {
  namespaced: true,

  state: {
    seasons: [],
    loading: false,
    pagination: {
      currentPage: 1,
      lastPage: 1,
      perPage: 10,
      total: 0,
    },
  },

  getters: {
    seasons: (state) => state.seasons,
    loading: (state) => state.loading,
    pagination: (state) => state.pagination,
  },

  actions: {
    async fetchSeasons({ commit }, { page = 1, limit = 10 } = {}) {
      try {
        commit("SET_LOADING", true);

        const res = await Service().get("../api/seasons", {
          params: { page, limit },
        });

        commit("SET_SEASONS", res.data);
        commit("SET_PAGINATION", {
          currentPage: res.pagination.current_page,
          lastPage: res.pagination.total_pages,
          perPage: res.pagination.per_page,
          total: res.pagination.total_items,
        });

        return { success: true };
      } catch (e) {
        console.error("Error fetching seasons: ", e);
        commit("SET_SEASONS", []);
        commit("SET_PAGINATION", {
          currentPage: 1,
          lastPage: 1,
          perPage: limit,
          total: 0,
        });
        return { success: false };
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async participateInSeason({ commit }, seasonId) {
      try {
        const res = await Service().post(
          "../api/seasons/season-participation",
          {
            season_id: seasonId,
          }
        );

        if (res.status) {
          // Update the season in the list to reflect new participation status
          commit("UPDATE_SEASON_PARTICIPATION", {
            seasonId,
            participationData: res.data,
          });
          return { success: true, message: res.message };
        } else {
          return { success: false, message: res.message };
        }
      } catch (e) {
        console.error("Error participating in season: ", e);
        return {
          success: false,
          message: e.response?.data?.message || "Failed to apply for season",
        };
      }
    },
  },

  mutations: {
    SET_SEASONS: (state, payload) => (state.seasons = payload),
    SET_LOADING: (state, payload) => (state.loading = payload),
    SET_PAGINATION: (state, payload) => {
      state.pagination = payload;
    },
    UPDATE_SEASON_PARTICIPATION: (state, { seasonId, participationData }) => {
      const seasonIndex = state.seasons.findIndex(
        (season) => season.season_id === seasonId
      );
      if (seasonIndex !== -1) {
        state.seasons[seasonIndex].registration_info = participationData;
        state.seasons[seasonIndex].user_application_status = "under_review";
        state.seasons[seasonIndex].can_register = false;
      }
    },
  },
};
